import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-alert",
  templateUrl: "./alert.component.html",
})
export class AlertComponent {
  readonly message = input<string>();
  readonly type = input.required<
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark"
  >();

  constructor() {}
}
